/* eslint-disable import/prefer-default-export */

import { whichVariant } from '../../selectors/configSelectors';
import {
  MVT_1066,
  MVT_1068,
  MVT_1164,
  MVT_1172,
  WEB_FUNNEL_HOLDOUT,
  RS_WORK_WITH_US_DROPDOWN,
  MVT_WEB_POSTCODES,
} from '../../flags/experiments';
import { TRACK_VIEWED_HOMEPAGE, TRACK_HOMEPAGE_LOCATION_SEARCH_SEEN } from './types';

export function trackViewedHomepage({ referralPreventedRedirect, isRedirectCookieAllowed }) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: TRACK_VIEWED_HOMEPAGE,
      payload: {
        name: 'Viewed Homepage',
        properties: {
          mvt_951_cwa_homepage_3: 'cwa',
          'Redirect Prevented By Referral': referralPreventedRedirect,
          'MVT_1164 Cookie Allowed': isRedirectCookieAllowed,
          [MVT_1066]: whichVariant(state, MVT_1066),
          [MVT_1068]: whichVariant(state, MVT_1068),
          [MVT_1164]: whichVariant(state, MVT_1164),
          [MVT_1172]: whichVariant(state, MVT_1172),
          [WEB_FUNNEL_HOLDOUT]: whichVariant(state, WEB_FUNNEL_HOLDOUT),
          [RS_WORK_WITH_US_DROPDOWN]: whichVariant(state, RS_WORK_WITH_US_DROPDOWN),
          [MVT_WEB_POSTCODES]: whichVariant(state, MVT_WEB_POSTCODES),
        },
      },
    });
  };
}

export function trackLocationSearchSeen(percentage) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: TRACK_HOMEPAGE_LOCATION_SEARCH_SEEN,
      payload: {
        name: 'Homepage LocationSearch seen',
        properties: {
          mvt_951_cwa_homepage_3: 'cwa',
          [MVT_1066]: whichVariant(state, MVT_1066),
          [MVT_1068]: whichVariant(state, MVT_1068),
          percentage,
        },
      },
    });
  };
}
